<template>
    <div class="side-nav-item" :class="{ 'side-nav-item--selected': selected }">
        <div class="side-nav-item__title">
            {{ title }}
        </div>
        <div class="side-nav-item__category">
            {{ category }}
        </div>
        <div class="side-nav-item__sub-category">
            <template v-if="Array.isArray(subCategory)">
                <span v-for="(subCategoryItem, index) in subCategory" :key="index">
                    {{ subCategoryItem }}
                </span>
            </template>
            <template v-else>
                {{ subCategory }}
            </template>
        </div>
        <div v-if="attribute === 'lspoint'" class="side-nav-item__attribute">
            <img src="/images/icons/lspoint.svg" alt="LS Point">
        </div>
        <div v-if="attribute === 'pinned'" class="side-nav-item__attribute">
            <img src="/images/icons/pin-success.svg" alt="Pinned">
        </div>
    </div>
</template>

<script>
export default {
    name: 'SideNavItem',
    props: {
        title: String,
        category: String,
        subCategory: String | Array,
        attribute: String,
        selected: Boolean
    }
}
</script>
